import React from 'react';
import { CircularProgress } from '@material-ui/core';

interface LoadingPanelProps {
    top?: number;
    left?:number;
}

const LoadingPanel: React.FC<LoadingPanelProps> = ({ top= 50, left = 50 }) => {
    return (
        <div className="k-loading-mask" style={{width:'99%', height: '99%'}}>
            <span className="k-loading-text">Loading</span>
            <CircularProgress
                style={{ position: 'absolute', top: `calc(${top}% - 20px)`, left: `calc(${left}% - 20px)` }}
                thickness={4}
            />
            <div className="k-loading-color"></div>
        </div>
    );
};

export default LoadingPanel;
